import { authConstants } from '../constants';

let user = JSON.parse(localStorage.getItem('user'));
let initialState = user
	? {
			logInSuccess: true,
			logInRequest: false,
			user,
			error: '',
			unrecognizedRoute: false,
	  }
	: {
			loggedIn: false,
			logInRequest: false,
			logInSuccess: false,
			unrecognizedRoute: false,
	  };

export const auth = (state = initialState, action) => {
	switch (action.type) {
		case authConstants.LOGIN_REQUEST: {
      		return (state = {
				...state,
				logInSuccess: false,
				logInRequest: true,
				unrecognizedRoute: false,
				user: action.user,
			});
		}

		case authConstants.LOGIN_SUCCESS: {
      		return (state = {
				...state,
				logInSuccess: true,
				unrecognizedRoute: false,
				user: action.user,
			});
		}

		case authConstants.LOGIN_FAILURE: {
			return (state = {
				...state,
				logInSuccess: false,
				logInRequest: false,
				unrecognizedRoute: false,
				error: action.error,
			});
		}

		case authConstants.LOGOUT:
			return {};
		default:
			return (state = {
				...state,
				unrecognizedRoute: true,
			});

		case authConstants.GET_USER_DATA_SUCCESS:
			return {
				...state,
				user: action.user,
			};
		case authConstants.GET_USER_DATA_REQUEST:
      
			return {
				...state,
				user: user,
			};
		case authConstants.GET_USER_DATA_FAILURE:
			return {
				...state,
				user: user,
			};

		case authConstants.ONBOARDING_LOGIN_EMAIL_SUCCESS:
			return {
				...state,
				response: action.response,
			};
		case authConstants.ONBOARDING_LOGIN_EMAIL_REQUEST:
			return {
				...state,
				response: action.response,
			};
		case authConstants.ONBOARDING_LOGIN_EMAIL_FAILURE:
			return {
				...state,
				response: action.response,
			};
	}
};



// WEBPACK FOOTER //
// ./src/store/reducers/auth.reducer.js